import React, { useEffect } from 'react'
import WebFont from 'webfontloader';
import Moment from 'react-moment';
import moment from 'moment';
// eslint-disable-next-line
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import { Container, Row, Card, Button, Table, Dropdown, Badge, Modal, Form, ListGroup, Col } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight, faCoins, faEye, faIndustry, faPlusCircle, faSchool, faSearch, faUser } from '@fortawesome/free-solid-svg-icons'
import NavBar from "../navbar/Navbar";
import SubNavBarC from "../navbar/SubNavbarCustomers";
import SubNavBarD from "../navbar/SubNavbarDefendants";
import { get, post } from '../../../controllers/endpoints.controller';
import { getUserToken, logout } from '../../../controllers/user.controller';


export default function NewBusiness(props) {

    const PAGE_TITLE = "Nueva persona jurídica";
    const PAGE_ICON = faIndustry;
    const [provinces, setProvinces] = React.useState([]);
    const [selectedProvince, setSelectedProvince] = React.useState("");
    const [color, setColor] = React.useState("#0D72B5");


    const handleProvince = (event) => {
        setSelectedProvince(event.target.value);
    };

    const handleColor = (event) => {
        setColor(event.target.value);
    };

    const handleIdentifier = (event) => {
        getIdentifier(event.target.value)
    };

    useEffect(() => {
        WebFont.load({
            google: {
                families: ['Roboto:100,300,400']
            }
        });

        document.title = `Demo - ${PAGE_TITLE}`;

        getProvinces();
    }, []);

    const getProvinces = async function () {
        const req = await get('/others/provinces', getUserToken());
        const res = await req.json();

        if (req.status === 200) {
            setProvinces(res);
        } else if (req.status === 403) {
            logout();
        } else {
            alert(res.message);
        }
    }

    const getIdentifier = async function (data) {
        const chain = {
            chain: data
        }
        const req = await post('/others/identifier', getUserToken(), chain);
        const res = await req.json();

        if (req.status === 200) {
            document.getElementById('textIdentifier').value = res.chain;
        } else if (req.status === 403) {
            logout();
        } else {
            alert(res.message);
            console.log(res)
        }
    }

    const createBusiness = async function () {
        const data = {
            cuit: document.getElementById('textCuit').value,
            legalName: document.getElementById('textLegalName').value,
            address: document.getElementById('textAddress').value,
            city: document.getElementById('textCity').value,
            province: selectedProvince,
            postalCode: document.getElementById('textPostalCode').value,
            order: document.getElementById('textOrder').value.length > 1 ? document.getElementById('textOrder').value : null,
            identifier: document.getElementById('textIdentifier').value,
            color: color,
        }

        const req = await post(`/${props.customers ? 'customers' : 'defendants'}/business`, getUserToken(), data);
        const res = await req.json();

        if (req.status === 201) {
            window.location.href = `/${props.customers ? 'clientes' : 'demandados'}/empresas`;
        } else if (req.status === 403) {
            logout();
        } else {
            console.log(res)
            alert(res.message);
        }
    }



    return (
        <div className='p-0' style={{ fontFamily: 'Roboto' }}>
            <style>{'body {background-color: #EBEBEB !important;}'}</style>
            <NavBar />
            {props.customers ? <SubNavBarC /> : <SubNavBarD />}

            <div style={{ height: 300, background: '#FAFAFA' }}>
                <Container>
                    <Row style={{ paddingTop: 10 }}>
                        <table className='w-75' style={{ marginLeft: 'auto', marginRight: 'auto' }}>
                            <tr>
                                <td style={{ fontSize: 45, fontWeight: 300 }}>
                                    <span style={{ color: '#A0A0A0' }}>{PAGE_TITLE}</span>
                                </td>
                                <td style={{ fontSize: 140, width: 150 }}>
                                    <FontAwesomeIcon icon={PAGE_ICON} style={{ fontSize: 140, color: "A0A0A0" }} />
                                </td>
                            </tr>
                        </table>
                    </Row>
                </Container>
            </div>

            <Container>
                <Row style={{ marginTop: -70 }}>
                    <Card className='cards content mb-5'>
                        <table className='content-options content'>
                            <tr>
                                <td className='content-options rows left'>
                                    <Link to={`/${props.customers ? 'clientes' : 'demandados'}/empresas`} className='link-primary'>
                                        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 8 }} />Volver a Empresas
                                    </Link>


                                </td>
                                <td className='content-options rows right'>

                                </td>
                            </tr>
                        </table>

                        <Container className='mt-4 mb-4'>
                            <Row>
                                <Col xs={6}>
                                    <table className='w-100'>
                                        <tr>
                                            <td className='pt-2' style={{ fontWeight: 'bold', width: 170 }} >Razón social</td>
                                            <td className='pt-2'>
                                                <Form.Group>
                                                    <Form.Control type="text" id="textLegalName" placeholder="" onChange = {(event) => handleIdentifier(event)} />
                                                </Form.Group>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='pt-2' style={{ fontWeight: 'bold', width: 170 }}>CUIT</td>
                                            <td className='pt-2'>
                                                <Form.Group>
                                                    <Form.Control type="text" id="textCuit" placeholder="" />
                                                </Form.Group>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='pt-2' style={{ fontWeight: 'bold' }}>Orden</td>
                                            <td className='pt-2'>
                                                <Form.Group>
                                                    <Form.Control type="text" id="textOrder" placeholder="" />
                                                </Form.Group>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='pt-2' style={{ fontWeight: 'bold' }}>Identificador</td>
                                            <td className='pt-2' >
                                                <Row>
                                                    <Col>
                                                        <Form.Control type="text" id="textIdentifier" placeholder="" />
                                                    </Col>
                                                    <Col>
                                                        <Form.Control
                                                            type="color"
                                                            id="exampleColorInput"
                                                            defaultValue="#0D72B5"
                                                            title="Choose your color"
                                                            onChange={(event) => handleColor(event)}
                                                        />
                                                    </Col>
                                                </Row>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='pt-2' style={{ fontWeight: 'bold' }}>Dirección</td>
                                            <td className='pt-2'>
                                                <Form.Group>
                                                    <Form.Control type="text" id="textAddress" placeholder="" />
                                                </Form.Group>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='pt-2' style={{ fontWeight: 'bold' }}>Localidad</td>
                                            <td className='pt-2'>
                                                <Form.Group>
                                                    <Form.Control type="text" id="textCity" placeholder="" />
                                                </Form.Group>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='pt-2' style={{ fontWeight: 'bold' }}>Provincia</td>
                                            <td className='pt-2'>
                                                <Form.Group>
                                                    <Form.Select className='cover content rows element' id="" onChange={(event) => handleProvince(event)}>
                                                        <option value="0">Seleccionar...</option>
                                                        {provinces.map((p, i) => (
                                                            <option key={i} id={i} value={p.name}>{p.name}</option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className='pt-2' style={{ fontWeight: 'bold' }}>Código postal</td>
                                            <td className='pt-2'>
                                                <Form.Group>
                                                    <Form.Control type="text" id="textPostalCode" placeholder="" />
                                                </Form.Group>
                                            </td>
                                        </tr>

                                    </table>
                                </Col>
                                <Col xs={6}>
                                    <table className='w-100'>


                                    </table>
                                </Col>
                            </Row>
                            <Form>


                            </Form>

                            <div className='mt-5' style={{ textAlign: 'right' }}>
                                <Button variant="success" onClick={createBusiness}>Siguiente<FontAwesomeIcon icon={faArrowRight} style={{ marginLeft: 8 }} /></Button>
                            </div>

                        </Container>
                    </Card>
                </Row>
            </Container>
        </div>
    )
}